
<div class="claims-wrapper">
  <div class="claims-header" (click)="goBack()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Upload Documents
  </div>

  <div class="claims-body">
    <div class="frame-1984079678_1685-9440">
 
      <fieldset>
        <div class="form-card">
          <div class="rows">
            <div class="col-12 text-center custom-heading">
              <h5 class="fs-title text-center">{{ selectedClaim.claimType }} Claim</h5>
              <!-- <p>We will reimburse the medical expenses.</p> -->
            </div>
          </div>
          <div class="form-box" style="max-height: 400px;overflow-y: scroll;">
            <h5 class="main-heading text-left">Upload the below documentation</h5>
            <small class="text-left">Upload all available set of documents, individual file size
              should be less than 5mb,
              overall file size should be less then 30mb</small><br />
            <small class="text-left">Supported files: Jpg, PDF, Jpg, jpeg, PDF, png, doc, docx,
              xlsx</small>
            <div name="auto-uploader" class="uplaoder-form">
              <div class="spinner-border text-primary" *ngIf="!isClaimDocumentsLoaded">
                <span class="sr-only">Loading...</span>
              </div>
    
              <div *ngIf="isClaimDocumentsLoaded && claimDocuments.length === 0" class="no-result-wrapper">
                <h5>No Document to Upload</h5>
              </div>
    
              <div *ngIf="isClaimDocumentsLoaded" class="docs-grid">
                <div *ngFor="let doc of claimDocuments">
                  <div class="pb-1 doc-name">{{ doc.description }}</div>
                  <div class="upload-documentation-wrapper mb-3 text-left">
                    <!-- <div *ngIf="doc.isMandatory === true" class="pb-1">
                    {{ doc.description }}<sup>*</sup>
                  </div> -->
    
                    <div class="upload-documentation-row">
                      <div class="documentation-row-left">
                        <button class="btn px-3 btn-sm mr-2" type="button" (click)="fileInput.click()">
                          <!-- <span>Upload</span> -->
                          <input #fileInput type="file" (change)="fileSelectionEvent($event, doc, 'Upload')"
                            style="display:none;" multiple accept=".xlsx,.jpg, .png, .doc, .docx,.pdf, .jpeg" />
                            <div>+</div>
                            <span>Upload</span>
                        </button>
                        <div [attr.id]="doc.documentId + 'delete'" style="display: none; width: 100%;">
                          <div class="uploaded-file-wrap">
                            <small [attr.id]="doc.documentId + 'para'" style="display: none;" class="uploaded-file-name"></small>
                            <button class="btn btn-sm p-0" (click)="deleteMultipleFile(doc, 'upload')">
                              <span class="material-icons">delete</span>
                            </button>
                          </div>
                        </div>
                      </div>
    
                      <div class="delete-file-wrapper">
                        <div class="errorMsg" [attr.id]="doc.documentId + 'invalid'" style="display: none;">
                          {{ uploadImageInvalidMsg }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border text-primary mr-3" *ngIf="multipleDocumentsUploading === true">
            <span class="sr-only">Submitting...</span>
          </div>
          <!-- <button class="btn btn-secondary previous action-button-previous mr-3"
            [hidden]="isDeclarationSubmitted || multipleDocumentsUploading === false"
            [disabled]="multipleDocumentsUploading === true" (click)="previousStep()">
            Previous
          </button> -->
          <button class="btn btn-primary next action-button"
            [disabled]="imageInvalid || imageInvalid === undefined || multipleDocumentsUploading === true"
            (click)="step2()">
            Upload Documents
          </button>
        </div>
      </fieldset>
    </div>
    <div *ngIf="currentStep === 3">
      <div class="form-card">
        <div class="row">
          <div class="col-12 text-center custom-heading">
            <div class="form-group modal-body">
              Documents uploaded successfully
            </div>
          </div>
        </div>
      </div>
      <!-- <button class="btn btn-primary next action-button" data-dismiss="modal">
      Close
    </button> -->
    </div>
  </div>
</div>